const translation = {
  pageTitle: 'Xin chào, hãy bắt đầu!👋',
  welcome: 'Chào mừng bạn đến với Dify, vui lòng đăng nhập để tiếp tục.',
  email: 'Địa chỉ Email',
  emailPlaceholder: 'Email của bạn',
  password: 'Mật khẩu',
  passwordPlaceholder: 'Mật khẩu của bạn',
  name: 'Tên người dùng',
  namePlaceholder: 'Tên người dùng của bạn',
  forget: 'Quên mật khẩu?',
  signBtn: 'Đăng nhập',
  installBtn: 'Cài đặt',
  setAdminAccount: 'Thiết lập tài khoản quản trị',
  setAdminAccountDesc: 'Quyền tối đa cho tài khoản quản trị, có thể được sử dụng để tạo ứng dụng và quản lý các nhà cung cấp LLM, v.v.',
  createAndSignIn: 'Tạo và đăng nhập',
  oneMoreStep: 'Một bước nữa',
  createSample: 'Dựa trên thông tin này, chúng tôi sẽ tạo một ứng dụng mẫu cho bạn',
  invitationCode: 'Mã mời',
  invitationCodePlaceholder: 'Mã mời của bạn',
  interfaceLanguage: 'Ngôn ngữ giao diện',
  timezone: 'Múi giờ',
  go: 'Đi đến Dify',
  sendUsMail: 'Gửi email giới thiệu của bạn cho chúng tôi, và chúng tôi sẽ xử lý yêu cầu mời.',
  acceptPP: 'Tôi đã đọc và chấp nhận chính sách bảo mật',
  reset: 'Vui lòng chạy lệnh sau để đặt lại mật khẩu của bạn',
  withGitHub: 'Tiếp tục với GitHub',
  withGoogle: 'Tiếp tục với Google',
  rightTitle: 'Mở khóa tiềm năng đầy đủ của LLM',
  rightDesc: 'Dễ dàng xây dựng ứng dụng AI hấp dẫn mắt, có thể vận hành và cải thiện được.',
  tos: 'Điều khoản dịch vụ',
  pp: 'Chính sách bảo mật',
  tosDesc: 'Bằng cách đăng ký, bạn đồng ý với',
  goToInit: 'Nếu bạn chưa khởi tạo tài khoản, vui lòng đi đến trang khởi tạo',
  donthave: 'Chưa có?',
  invalidInvitationCode: 'Mã mời không hợp lệ',
  accountAlreadyInited: 'Tài khoản đã được khởi tạo',
  error: {
    emailEmpty: 'Địa chỉ Email là bắt buộc',
    emailInValid: 'Vui lòng nhập một địa chỉ email hợp lệ',
    nameEmpty: 'Tên là bắt buộc',
    passwordEmpty: 'Mật khẩu là bắt buộc',
    passwordInvalid: 'Mật khẩu phải chứa chữ và số, và độ dài phải lớn hơn 8',
  },
  license: {
    tip: 'Trước khi bắt đầu Phiên bản Cộng đồng của Dify, hãy đọc',
    link: 'Giấy phép mã nguồn mở trên GitHub',
  },
  join: 'Tham gia',
  joinTipStart: 'Mời bạn tham gia',
  joinTipEnd: 'đội tại Dify',
  invalid: 'Liên kết đã hết hạn',
  explore: 'Khám phá Dify',
  activatedTipStart: 'Bạn đã tham gia',
  activatedTipEnd: 'đội',
  activated: 'Đăng nhập ngay',
  adminInitPassword: 'Mật khẩu khởi tạo quản trị viên',
  validate: 'Xác thực',
}

export default translation
